import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'enum',
    standalone: false
})
export class EnumPipe implements PipeTransform {

    transform(value: string | string[] | null | undefined, enums: Array<{ value: string; displayName: string }>): string {

        if (!enums || enums.length === 0 || value == null) {
            return '';
        }

        // Handle an array of strings
        if (Array.isArray(value)) {
            if (value.length === 0) { return ''; }
            const displayNames = value
                .map((val: string) => enums.find((i) => i.value === val)?.displayName || '')
                .filter((displayName: string) => !!displayName);
            return displayNames.join(', ');
        }

        // Handle a single string value
        const found = enums.find((i) => i.value === value)?.displayName;
        return found || '';
    }

}
